import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';

//upload the files to firebase and get the URL
export default async function fileUpload(file, type, which, folder) {
    const orgId = localStorage.getItem('orgId') || 'org';
    const supId = localStorage.getItem('supId') || 'sup';
    let storageRef;

    if (which === 'create') {
        storageRef = ref(
            storage,
            `${process.env.REACT_APP_TRIPS_FILE_PATH}/${type}/${orgId}/${folder}/trvto-${file.name}`
        );
    } else if (which === 'logo') {
        storageRef = ref(storage, `${process.env.REACT_APP_TRIPS_FILE_PATH}/${type}/${orgId}/logo/trvto-${file.name}`);
    } else if (which === 'blog') {
        storageRef = ref(
            storage,
            `${process.env.REACT_APP_TRIPS_FILE_PATH}/support/${supId}/${folder}/trvto-${file.name}`
        );
    }

    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    return downloadURL;
}
